import axios from "axios";

const state = {
    brands:{},
	hardwarebrands:{},
	hardwarercollections:{},
	hardwarercolors:{},
    types:{},
    patterns:{},
    colors:{},
    scale:{},
	fabriccolors:{},
    uses:{},
    passes:{},
    fabrics:{},
    trim:{},
    samples:{},
	hardwares:{},
    status:{},
    booksdrop:{},
    patternsdrop:{},
    colorsdrop:{},
    cartproducts:{
        ITEMS:[],
        subtotal:null,
        shipping:null,
        total:null
    },
    isCartStateEmpty:false,
	checkoutinfo:{}
};

const getters = {
    brands: state => state.brands,
	hardwarebrands: state => state.hardwarebrands,
	hardwarercollections: state =>state.hardwarercollections,
	hardwarercolors: state => state.hardwarercolors,
    types: state => state.types,
    patterns: state => state.patterns,
    colors: state => state.colors,
    scale: state => state.scale,
	fabriccolors: state => state.fabriccolors,
    uses: state => state.uses,
    passes: state => state.passes,
    fabrics: state => state.fabrics,
	trim: state => state.trim,
    hardwares:state => state.hardwares,
    samples: state => state.samples,
    status: state => state.status,
    booksdrop: state => state.booksdrop,
    patternsdrop: state => state.patternsdrop,
    colorsdrop: state => state.colorsdrop,
    cartproducts: state => state.cartproducts,
    isCartStateEmpty: state => state.isCartStateEmpty,
	checkoutinfo: state => state.checkoutinfo
};

const actions = {
    loadBrands({ commit }) {
        return axios.get(`/shop/api/fabric-brands`).then(response => {
            commit("BRANDS_LOADED", response.data);

            return response;
        });
    },

	loadHardwareBrands({ commit }) {
        return axios.get(`/shop/api/hardware-brands`).then(response => {
            commit("HARDWARE_BRANDS_LOADED", response.data);

            return response;
        });
    },

    loadTypes({ commit }) {
        return axios.get(`/shop/api/fabric-types`).then(response => {
            commit("TYPES_LOADED", response.data);

            return response;
        });
    },

    loadColors({ commit }, pc_type) {
        return axios.get(`/shop/api/fabric-colors/${pc_type}`).then(response => {
            commit("COLORS_LOADED", response.data);

            return response;
        });
    },

    loadScale({ commit }) {
        return axios.get(`/shop/api/fabric-scale`).then(response => {
            return response;
        });
    },

	loadPatternsColors({ commit },pattern) {
        return axios.get(`/shop/api/product-colors/fabric/${pattern}`).then(response => {
            commit("PATTERNSCOLORS_LOADED", response.data);

            return response;
        });
    },

	loadCollection({ commit },brand) {
        return axios.get(`/shop/api/hardware-collection/${brand}`).then(response => {
            commit("HARDWARE_COLLECTION_LOADED", response.data);

            return response;
        });
    },

	loadHardwareColors({ commit },brand) {
        return axios.get(`/shop/api/hardware-colors/${brand}`).then(response => {
            commit("HARDWARE_COLORS_LOADED", response.data);

            return response;
        });
    },

    loadPatterns({ commit },pc_type) {
        return axios.get(`/shop/api/fabric-patterns/${pc_type}`).then(response => {
            commit("PATTERNS_LOADED", response.data);

            return response;
        });
    },

    loadUses({ commit }) {
        return axios.get(`/shop/api/fabric-use`).then(response => {
            commit("USES_LOADED", response.data);

            return response;
        });
    },

    loadPasses({ commit }) {
        return axios.get(`/shop/api/fabric-passes`).then(response => {
            commit("PASSES_LOADED", response.data);

            return response;
        });
    },

    loadPerformance({ commit }) {
        return axios.get(`/shop/api/fabric-performance`).then(response => {
            return response;
        });
    },

    loadfabricFilters({ commit }, requestquery) {
        return axios.get(`/shop/api/fabric-filters?${requestquery}`).then(response => {
            return response.data;
        });
    },

    loadtrimFilters({ commit }, requestquery) {
        return axios.get(`/shop/api/trim-filters?${requestquery}`).then(response => {
            return response.data;
        });
    },

    loadsamplefilters({ commit }) {
        return axios.get(`/shop/api/sample-filters`).then(response => {
            return response.data;
        });
    },

    loadfabricProducts({ commit }, requestquery) {
        return axios.get(`/shop/api/product/fabrics?${requestquery}`).then(response => {
            commit("FABRICPRODUCT_LOADED", response.data);

            return response;
        });
    },

	loadtrimProducts({ commit }, requestquery) {
        return axios.get(`/shop/api/product/trim?${requestquery}`).then(response => {
            commit("TRIMPRODUCT_LOADED", response.data);

            return response;
        });
    },

	loadhardwareProducts({ commit }, requestquery) {
        return axios.get(`/shop/api/product/hardwares?${requestquery}`).then(response => {
            commit("HARDWAREPRODUCT_LOADED", response.data);

            return response;
        });
    },
    loadsampleProducts({ commit }, requestquery) {
        return axios.get(`/shop/api/product/samples?${requestquery}`).then(response => {
            commit("SAMPLEPRODUCT_LOADED", response.data);
            return response;
        });
    },

    loadHardwareProductInfo({ commit },{itemid, inventcolorid}) {
        return axios.get(`/shop/api/hardware-info/${itemid}/${inventcolorid}`).then(response => {
            return response.data;
        });
    },

    loadSampleProductInfo({ commit },{itemid}) {
        return axios.get(`/shop/api/sample-info/${itemid}`).then(response => {
            return response.data;
        });
    },

    loadStatus({ commit },pc_type) {
        return axios.get(`/shop/api/product-availablity/${pc_type}`).then(response => {
            commit("STATUS_LOADED", response.data);

            return response;
        });
    },

    loadBooksdrop({ commit },pc_type) {
        return axios.get(`/shop/api/product-books/${pc_type}`).then(response => {
            commit("BOOKSDROP_LOADED", response.data);

            return response;
        });
    },

    loadPatternsdrop({ commit },pc_type) {
        return axios.get(`/shop/api/product-patterns/${pc_type}`).then(response => {
            commit("PATTERNSDROP_LOADED", response.data);

            return response;
        });
    },

    loadColorsdrop({ commit },pc_type) {
        return axios.get(`/shop/api/product-colors/${pc_type}/all`).then(response => {
            commit("COLORSDROP_LOADED", response.data);

            return response;
        });
    },
    loadCart({ commit },customernumber) {
        return axios.get(`/shop/api/cart/products/${customernumber}`).then(response => {
            commit("CARTPRODUCTS_LOADED", response.data);
            if(response.data.ITEMS.length < 1){
                commit("CARTISEMPTY", true);
            }

            return response;
        });
    },
    deleteCartItem({ commit },{id,user_id}) {
        return axios.delete(`/shop/api/cart/deletecart/${id}/${user_id}`).then(response => {
            return response;
        });
    },
    updateCartQty({ commit },obj) {
        return axios.put(`/shop/api/cart/updatecart/${obj.id}?quantity=${obj.val}`).then(response => {
            return response;
        });
    },
    loadCountries({ commit }) {
        return axios.get(`/shop/api/getcountries`).then(response => {
            return response;
        });
    },
    loadStates({ commit },country_id) {
        return axios.get(`/shop/api/getstates/${country_id}`).then(response => {
            return response;
        });
    },

	loadCheckoutinfo({ commit },user_id) {
        return axios.get(`/shop/api/cart/checkout/${user_id}`).then(response => {
            return response;
        });
    },

    placeOrder({ commit }, {form,user_id,is_online}) {
		return axios.post(`/shop/api/checkout/directpost/${user_id}/${is_online}`, {
            form
          }).then(response => {
			commit("CHECKOUTINFO_LOADED", response.data);
			return response.data;
        });
    },

    loadPricesheetBooks({ commit }) {
        return axios.get(`/shop/api/booksampleorder/books`).then(response => {
            return response;
        });
    },

    loadPDFPricebyBooks({ commit }, form) {
        return axios.get(`/shop/api/booksampleorder/print-pdf?books=${form.books}&retail_type=${form.radio}&qty=${form.quantity}&qty1=${form.quantity1}`,{
            responseType: 'blob',
        }).then(response => {
            return response;
        });
    },


	loadPDFInvoice({ commit }, {invoiceid,customer_id}) {
        return axios.get(`/shop/api/account/invoice-pdf/${invoiceid}/${customer_id}`,{
            responseType: 'blob',
        }).then(response => {
            return response;
        });
    },

	loadProductPDF({ commit },{itemid, inventcolorid}) {
       return axios.get(`/shop/api/product-pdf/${itemid}/${inventcolorid}`,{
            responseType: 'blob',
        }).then(response => {
            return response;
        });
    },


    loadProducthardwarePDF({ commit },{itemid, inventcolorid}) {
        return axios.get(`/shop/api/product-hardware-pdf/${itemid}/${inventcolorid}`,{
             responseType: 'blob',
         }).then(response => {
             return response;
         });
     },

     loadProductsamplePDF({ commit },{itemid}) {
        return axios.get(`/shop/api/product-sample-pdf/${itemid}`,{
             responseType: 'blob',
         }).then(response => {
             return response;
         });
     },

    loadFauxfurdata({ commit }) {
        return axios.get(`/shop/api/products/fauxfur`).then(response => {
            return response;
        });
    },

    loadFabricSearchProducts({ commit }, requestquery) {
        return axios.get(`/shop/api/fabric/search?${requestquery}`).then(response => {
            return response;
        });
    },

    loadTrimSearchProducts({ commit }, requestquery) {
        return axios.get(`/shop/api/trim/search?${requestquery}`).then(response => {
            return response;
        });
    },

    loadSampleSearchProducts({ commit }, requestquery) {
        return axios.get(`/shop/api/sample/search?${requestquery}`).then(response => {
            return response;
        });
    },

    loadShowroomSearchProducts({ commit }, requestquery) {
        return axios.get(`/shop/api/showroom/search?${requestquery}`).then(response => {
            return response;
        });
    },

    loadCollectionSearchProducts({ commit }, requestquery) {
        return axios.get(`/shop/api/collection/search?${requestquery}`).then(response => {
            return response;
        });
    },

    loadsearchbyimageProducts({ commit }, term) {
        return axios.get(`/shop/api/loadproductsbyimage?g=${term}`).then(response => {
            return response;
        });
    },

    loadCoordinatingFabrics({ commit },{itemid, inventcolorid}) {
        return axios.get(`/shop/api/coordinating-fabrics/${itemid}/${inventcolorid}`).then(response => {
            return response;
        });
    },

    loadfabricCollectionFilters({ commit }, requestquery) {
        return axios.get(`/shop/api/fabric-collection-filters?${requestquery}`).then(response => {
            return response.data;
        });
    },

    loadfabricCollections({ commit }, requestquery) {
        return axios.get(`/shop/api/collections/fabrics?${requestquery}`).then(response => {
            return response;
        });
    },

    loadtrimCollectionFilters({ commit }, requestquery) {
        return axios.get(`/shop/api/trim-collection-filters?${requestquery}`).then(response => {
            return response.data;
        });
    },

    loadtrimCollections({ commit }, requestquery) {
        return axios.get(`/shop/api/collections/trim?${requestquery}`).then(response => {
            return response;
        });
    },

    isShowRoomByItem({commit}, itemid){
        return axios.get(`/shop/api/product/is-showroom-by-item-id/${itemid}`).then(response => {
            return response;
        });
    },

    isShowRoomByColor({commit}, colorname){
        return axios.get(`/shop/api/product/is-showroom-by-color-name/${colorname}`).then(response => {
            return response;
        });
    },

    loadCustomImageUpload({commit}, form) {
        return axios.post(`/shop/api/product/custom-print-image-upload`, form, {headers: { 'content-type': 'multipart/form-data' }})
            .then(response => {
                return response;
            });
    },

    getCustomImageUpload({commit}, id) {
        return axios.post(`/shop/api/product/custom-print-image-upload/${id}`)
            .then(response => {
                return response;
            });
    },

    customPrintImageDelete({commit}, id) {
        return axios.post(`/shop/api/product/custom-print-image-delete/${id}`)
            .then(response => {
                return response;
            });
    },

    getProductBaseFabrics({commit}, form) {
        return axios.post(`/shop/api/get-product-base-fabric`, form)
            .then(response => {
                return response;
            });
    },

    getProductMinMaxPrice({ commit }, form) {
        return axios.post(`/shop/api/get-product-min-max-price`, form)
            .then(response => {
                return response;
            });
    }
};

const mutations = {

    BRANDS_LOADED: (state, data) => {
        state.brands = data;
    },

	HARDWARE_BRANDS_LOADED: (state, data) => {
        state.hardwarebrands = data;
    },
	HARDWARE_COLLECTION_LOADED: (state, data) => {
        state.hardwarercollections = data;
    },

	HARDWARE_COLORS_LOADED: (state, data) => {
        state.hardwarercolors = data;
    },

    TYPES_LOADED: (state, data) => {
        state.types = data;
    },

    COLORS_LOADED: (state, data) => {
        state.colors = data;
    },

	PATTERNSCOLORS_LOADED: (state, data) => {
        state.fabriccolors = data;
    },

    PATTERNS_LOADED: (state, data) => {
        state.patterns = data;
    },

    USES_LOADED: (state, data) => {
        state.uses = data;
    },

    PASSES_LOADED: (state, data) => {
        state.passes = data;
    },

    FABRICPRODUCT_LOADED: (state, data) => {
        state.fabrics = data;
    },

    TRIMPRODUCT_LOADED: (state, data) => {
        state.trim = data;
    },

    HARDWAREPRODUCT_LOADED: (state, data) => {
        state.hardwares = data;
    },

    SAMPLEPRODUCT_LOADED: (state, data) => {
        state.samples = data;
    },

    STATUS_LOADED: (state, data) => {
        state.status = data;
    },

    BOOKSDROP_LOADED: (state, data) => {
        state.booksdrop = data;
    },

    PATTERNSDROP_LOADED: (state, data) => {
        state.patternsdrop = data;
    },

    COLORSDROP_LOADED: (state, data) => {
        state.colorsdrop = data;
    },

    CARTPRODUCTS_LOADED: (state, data) => {
        state.cartproducts = data;
    },

    CARTISEMPTY: (state, data) => {
        state.isCartStateEmpty = data;
    },

	CHECKOUTINFO_LOADED: (state, data) => {
        state.checkoutinfo = data;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
